import { Card } from 'antd';
const DirectMarkerIcon = ({ width = 12, className = '' }: { width?: number; className?: string }) => (
  <svg width={width} height={width} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M6.36851 13.1024C6.7175 14.1514 7.3795 14.1884 7.8465 13.1884L13.1555 1.81337C13.6225 0.811366 13.1895 0.379366 12.1885 0.846366L0.812505 6.15437C-0.188495 6.62137 -0.150495 7.28337 0.897505 7.63337L5.0005 9.00037L6.36851 13.1024Z" fill="var(--s247-primary, #B3446D)"/>
  </svg>
);

const MarkerIcon = ({ width = 12, className = '' }: { width?: number; className?: string }) => (
  <svg width={width} height={width * 18 / 15} viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="marker-icon-grad" x1="11.5" y1="-2" x2="-5" y2="22.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #AC2B90)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #EE5B33)"/>
      </linearGradient>
    </defs>
    <path d="M7.5 0.791687C9.38967 0.791687 11.2019 1.54235 12.5381 2.87855C13.8743 4.21475 14.625 6.02702 14.625 7.91669C14.625 10.8664 12.3767 13.9571 7.975 17.2584C7.83797 17.3611 7.67129 17.4167 7.5 17.4167C7.32871 17.4167 7.16203 17.3611 7.025 17.2584C2.62333 13.9571 0.375 10.8664 0.375 7.91669C0.375 6.02702 1.12567 4.21475 2.46186 2.87855C3.79806 1.54235 5.61033 0.791687 7.5 0.791687ZM7.5 5.54169C6.87011 5.54169 6.26602 5.79191 5.82062 6.23731C5.37522 6.68271 5.125 7.2868 5.125 7.91669C5.125 8.54658 5.37522 9.15067 5.82062 9.59607C6.26602 10.0415 6.87011 10.2917 7.5 10.2917C8.12989 10.2917 8.73398 10.0415 9.17938 9.59607C9.62478 9.15067 9.875 8.54658 9.875 7.91669C9.875 7.2868 9.62478 6.68271 9.17938 6.23731C8.73398 5.79191 8.12989 5.54169 7.5 5.54169Z" fill="url(#marker-icon-grad)"/>
  </svg>
);
import OrderCancelled from 'Assets/icon/order-cancelled.svg';
import OrderFinish from 'Assets/icon/order-finish.svg';
import OrderReceiving from 'Assets/icon/order-receiving.svg';
import { useEffect, useState } from 'react';
import { classPrefix } from 'Utilities/global';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { DTOOrder } from 'Services/v1/cargo-direct/dto';
import './index.scss';

const AddressInfo = (props: DTOOrder) => {
	const { t } = useTranslation();
	const [estimationTime, setEstimationTime] = useState('');
	const {
		senderAddress,
		receiverAddress,
		fromName,
		fromPhone,
		toName,
		toPhone,
		statusName,
		minEndTime,
		timeSlotTo,
		timeSlotFrom
	} = props;

	useEffect(()=>{
		const timeSlotFromTime = new Date(`${minEndTime?.slice(0,10)} ${timeSlotFrom}`);
		const timeSlotToTime = new Date(`${minEndTime?.slice(0,10)} ${timeSlotTo}`);
		const formattedETA = `${moment(timeSlotFromTime).format('HH:mm')} - ${moment(timeSlotToTime).format('HH:mm DD/MM/YYYY')}`;
		setEstimationTime(formattedETA);
	},[minEndTime, timeSlotFrom ,timeSlotTo])

	return (
		<>
			<Card
				className={`${classPrefix}-address-info-container mb-4`}
				bordered={false}
			>
				<div className="order-status p-5 mb-2">
					<div className="d-flex justify-content-between">
						<div>
							<div className="order-status-text fw-bold">
								{statusName && t(`order_statusName_${statusName}`)}
							</div>
							{statusName === 'SENDING' ? (
								<div className="order-status-time">
									{t('order_estimated_delivery')}{' '}
									<span className="fw-500">{estimationTime}</span>
								</div>
							) : (
								<div className="order-status-time">
									{statusName && t(`order_msg_status_${statusName}`)}
								</div>
							)}
						</div>
						{statusName === 'RECEIVING' && (
							<img src={OrderReceiving} width="80" />
						)}
						{statusName === 'FINISHED' && <img src={OrderFinish} width="80" />}
						{statusName === 'CANCELLED' && (
							<img src={OrderCancelled} width="80" />
						)}
					</div>
				</div>
				<div className="row">
					<div className="pickup-info col-md-6 col-sm-12 col-xs-12 mb-2">
						<div className="pickup-info-label mb-1">
							<DirectMarkerIcon width={12} className="mr-1" />
							<span>{t('order_sender_address')}</span>
						</div>
						<div className="mb-1 fw-500">
							{fromName} - {fromPhone}
						</div>
						<div className="pickup-info-address">{senderAddress}</div>
					</div>
					<div className="pickup-info col-md-6 col-sm-12 col-xs-12">
						<div className="pickup-info-label mb-1">
							<MarkerIcon width={12} className="mr-1" />
							<span>{t('order_receiver_address')}</span>
						</div>
						<div className="mb-1 fw-500">
							{toName} - {toPhone}
						</div>
						<div className="pickup-info-address">{receiverAddress}</div>
					</div>
				</div>
			</Card>
		</>
	);
};

export default AddressInfo;
